module.exports = __webpack_public_path__ + "img/ai.7d54a9d9.svg";